// Your Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = 'G-2KDK1W4E1H';

// Check if we're on production domain
const isProduction = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'www.smilesflow.com' || window.location.hostname === 'smilesflow.com';
};

// Respect cookie consent for analytics
export const isAnalyticsAllowed = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(window.cookieConsent?.analytics);
};

// Initialize Google Analytics (production only)
export const initGA = () => {
  if (isProduction() && GA_MEASUREMENT_ID && window.gtag && isAnalyticsAllowed()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views (production only)
export const trackPageView = (url, title) => {
  if (isProduction() && GA_MEASUREMENT_ID && window.gtag && isAnalyticsAllowed()) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
      page_title: title,
    });
  }
};

// Track custom events (production only with fallback to console)
export const trackEvent = (eventName, params = {}) => {
  if (isProduction() && GA_MEASUREMENT_ID && window.gtag && isAnalyticsAllowed()) {
    window.gtag('event', eventName, params);
  } else {
    console.log('Analytics event:', eventName, params);
  }
};

 
